import React from "react";

import { admin_cse } from "@/config/roles";
import { Button2 } from "@/ui2/atoms/Button";
import { CheckboxOld } from "@/component-library";
import { cn } from "@/lib/helpers/cn";
import { DashboardCard2 } from "@/ui2/molecules/DashboardCard2";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { getRole, isAuthorized } from "@/redux/actions/auth";
import { Heading2 } from "@/ui2/atoms/Heading";
import images from "@/utils/images";

import { getBadges, getMetaData, getNoteIcon, getSubTitle, getTitle } from "./helpers";

const isAuthorizedToViewFullNote = (note) => {
  const isBhsTherapySessionNote =
    (note.provider_type === "BEHAVIORAL" || note.provider_type === "BEHAVIORAL_INTAKE") &&
    (note.note_type === "Video Consultation" || note.version === 2);

  switch (getRole()) {
    case "provider:pcp":
      return !isBhsTherapySessionNote;

    default:
      return true;
  }
};

export const MemberProfileExportableNote = ({
  isSelectedForExport,
  note,
  selectNoteToExport,
  viewFullNote,
}) => {
  const isAuthorizedToExportNotes = isAuthorized(admin_cse);
  const badges = getBadges(note);
  const cpt_code = note.cpt_code;
  const icon = getNoteIcon(note);
  const metaData = getMetaData(note);
  const subTitle = getSubTitle(note);
  const title = getTitle(note);

  return (
    <li key={note.id} {...getAutomationDataAttr("member-profile-exportable-note")}>
      <DashboardCard2
        className="tw:p-0!"
        classNameChildren={cn(
          "tw:grid tw:gap-4 tw:max-lg:justify-items-start tw:lg:items-center",
          "tw:min-h-24 tw:px-7 tw:py-3",
          isAuthorizedToExportNotes
            ? "tw:lg:grid-cols-[min-content_2fr_0.6fr_0.75fr_min-content]"
            : "tw:lg:grid-cols-[2fr_0.6fr_0.75fr_min-content]",
        )}
      >
        {isAuthorizedToExportNotes && (
          <div className="tw:mr-2">
            <CheckboxOld checked={isSelectedForExport} onClick={() => selectNoteToExport(note)} />
          </div>
        )}

        <div className="tw:flex tw:items-center tw:gap-x-4">
          {icon && <img alt="" className="tw:h-9" src={images(`./icons/${icon}`)} />}

          <p className="tw:flex tw:flex-col">
            <Heading2
              as="b"
              size={1}
              {...getAutomationDataAttr("MemberProfileExportableNoteTitle")}
            >
              {title}
            </Heading2>

            <span className="body-md">{subTitle}</span>
            <span className="body-sm">{cpt_code}</span>
          </p>
        </div>

        <ul className="tw:flex tw:items-center tw:justify-center tw:gap-1 tw:lg:flex-col">
          {badges}
        </ul>

        <div>{metaData}</div>

        {isAuthorizedToViewFullNote(note) && (
          <Button2
            className="tw:h-auto tw:p-2 tw:text-(--brand-bright-purple-600) tw:underline tw:hover:text-(--brand-bright-purple-800) tw:hover:no-underline"
            onPress={viewFullNote}
            variant="text"
            {...getAutomationDataAttr("member-profile-view-full-note-button")}
            {...getAutomationDataAttr(note?.id, "data-id")}
          >
            View Full Note
          </Button2>
        )}
      </DashboardCard2>
    </li>
  );
};
